<div [ngClass]="{ 'col-6 col-3--md col-4--sm': !config.fullWidth }">
  <div class="form-group">
    @if (config.label) {
      <label
        [for]="config.name"
        [ngClass]="{
          'form-label--error': config.mainControl?.hasError
        }"
      >
        {{ config.label }}
        @if (showMandatory) {
          <span>*</span>
        }
      </label>
    }
    @if (isPasswordControl && config.mainControl) {
      <air-password-control
        [group]="group"
        [control]="config.mainControl"
        [formState]="formState"
        (changeTrigger)="onMainChange($event)"
      ></air-password-control>
    }
    @if (!isPasswordControl && config.mainControl) {
      <air-text-control
        [group]="group"
        [control]="config.mainControl"
        [formState]="formState"
        [userEventSource]="userEventSource"
      ></air-text-control>
    }
  </div>
  @if (config.mainControl?.hasError && control.errorMessages?.length) {
    <div class="form-error">
      @for (message of control.errorMessages; track message) {
        <div class="form-error__message">
          {{ message }}
        </div>
      }
    </div>
  }
</div>
<div [ngClass]="{ 'col-6 col-3--md col-4--sm': !config.fullWidth }">
  <div class="form-group">
    @if (config.repeatControlLabel) {
      <label
        [for]="repeatControlName"
        [ngClass]="{
          'form-label--error': config.repeatControl?.hasError
        }"
      >
        {{ config.repeatControlLabel }}
        @if (showMandatory) {
          <span>*</span>
        }
      </label>
    }
    @if (isPasswordControl && config.repeatControl) {
      <air-password-control
        [group]="group"
        [control]="config.repeatControl"
        [formState]="formState"
        (changeTrigger)="onRepeatChange($event)"
      ></air-password-control>
    }
    @if (!isPasswordControl && config.repeatControl) {
      <air-text-control
        [group]="group"
        [control]="config.repeatControl"
        [formState]="formState"
        [userEventSource]="userEventSource"
      ></air-text-control>
    }
  </div>
  <div class="form-error" [hidden]="!config.repeatControl?.hasError">
    <div class="form-error__message">
      {{ config.repeatErrorMessage }}
    </div>
  </div>
</div>
@if (config.showValidationChecklist) {
  <div class="form__description form__checklist" [ngClass]="{ 'col-12 col-6--md col-4--sm': config.fullWidth === false }">
    @if (config.validationChecklistTitle) {
      <p>
        <strong>{{ config.validationChecklistTitle }}</strong>
      </p>
    }
    @for (validator of control.validators; track validator) {
      @if (!validator.hideFromChecklist && validator.errorMessage) {
        <div
          [ngClass]="{
            'form__checklist--error': formControl?.touched && validator.hasError,
            'form__checklist--valid': !validator.hasError
          }"
        >
          @if (formControl?.touched) {
            <i class="icon" [ngClass]="validator.hasError ? 'icon-ui-close--sm' : 'icon-ui-checkmark--sm'"></i>
          }
          @if (!formControl?.touched) {
            <i class="icon" [ngClass]="validator.hasError ? 'icon-ui-dot' : 'icon-ui-checkmark--sm'"></i>
          }
          <span>{{ validator.errorMessage }}</span>
        </div>
      }
    }
    <div
      [ngClass]="{
        'form__checklist--error': formControl?.touched && formRepeatControl?.touched && repeatCheckHasError,
        'form__checklist--valid': formControl?.touched && !repeatCheckHasError
      }"
    >
      @if (formControl?.touched && formRepeatControl?.touched) {
        <i class="icon" [ngClass]="repeatCheckHasError ? 'icon-ui-close--sm' : 'icon-ui-checkmark--sm'"></i>
      }
      @if (!formControl?.touched || !formRepeatControl?.touched) {
        <i class="icon" [ngClass]="!formControl?.touched || repeatCheckHasError ? 'icon-ui-dot' : 'icon-ui-checkmark--sm'"></i>
      }
      <span>{{ config.repeatChecklistMessage || config.repeatErrorMessage }}</span>
    </div>
  </div>
}
